<template>
<div>
    <div class="full">
        <div class="full">
            <div class="mainheader">
                <div class="half">
                    {{ creatingNewEmployee ? $t('pages.employeeCoreData.newEmployee') : $t('pages.employeeCoreData.personalData') }}
                </div>
            </div>

        </div>
        <div class="third left">
            <div class="header">
                <div class="label">{{ $t('pages.employeeCoreData.nameAddress') }}</div>
            </div>
            <div class="full">
                <div class="half left">
                    <div class="label">{{ $t('pages.employeeCoreData.firstName') }}</div>
                </div>
                <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory:mandatoryAndMissing('firstName')}">
                    <input :readonly="!editing" type="text" v-model="savedEmployee.firstName"/>
                </div>
            </div>
            <div class="full">
                <div class="half left">
                    <div class="label">{{ $t('pages.employeeCoreData.lastName') }}</div>
                </div>
                <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory:mandatoryAndMissing('lastName')}">
                    <input :readonly="!editing" type="text" v-model="savedEmployee.lastName"/>
                </div>
            </div>
            <div class="full">
                <div class="half left">
                    <div class="label">{{ $t('pages.employeeCoreData.dob') }}</div>
                </div>
                <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory:mandatoryAndMissing('dob')}">
                    <input :readonly="!editing" type="date" :value="dateOfBirth" @input="dobChanged"/>
                </div>
            </div>
            <div class="full">
                <div class="half left">
                    <div class="label">{{ $t('pages.employeeCoreData.maidenName') }}</div>
                </div>
                <div class="half cd-input" v-bind:class="{roinput: !editing}">
                    <input :readonly="!editing" type="text" v-model="savedEmployee.maidenName"/>
                </div>
            </div>
            <div class="full">
                <div class="half left">
                    <div class="label">{{ $t('pages.employeeCoreData.pob') }}</div>
                </div>
                <div class="half cd-input" v-bind:class="{roinput: !editing}">
                    <input :readonly="!editing" type="text" v-model="savedEmployee.pob"/>
                </div>
            </div>


            <div class="full split-bottom-tightest">
                <div class="half left">
                    <div class="label">{{ $t('pages.employeeCoreData.socialsecurity') }}</div>
                </div>
                <div class="half cd-input" v-bind:class="{roinput: !editing || DisallowEditingHiddenFields, mandatory:mandatoryAndMissing('socialsecurity')}">
                    <input :readonly="!editing || DisallowEditingHiddenFields" type="text" v-model="savedEmployee.socialsecurity"/>
                </div>
            </div>
            <div class="full">
                <div class="half left">
                    <div class="label">{{ $t('pages.employeeCoreData.nationality') }}</div>
                </div>
                <div class="half cd-input" v-bind:class="{roinput: !editing || DisallowEditingHiddenFields, mandatory:mandatoryAndMissing('nationality')}">
                    <dropdownsearch v-if="editing && !DisallowEditingHiddenFields" style="width: 100%;" class="filters" :state="filtersNationality"/>
                    <input v-else type="text" :readonly="true" v-model="displayNationality"/>
                </div>
            </div>
            <div class="full">
                <div class="half left">
                    <div class="label">{{ $t('pages.employeeCoreData.citizenType') }}</div>
                </div>
                <div class="half cd-input" v-bind:class="{roinput: !editing || DisallowEditingHiddenFields, mandatory:mandatoryAndMissing('citizenType')}"> <!-- lower z-index then selection above ensure above selection overlays this one -->
                    <dropdownsearch v-if="editing && !DisallowEditingHiddenFields" style="width: 100%;" class="filters" :state="filtersCitizen"/>
                    <input v-else type="text" :readonly="true" v-model="displayCitizenType"/>
                </div>
            </div>
             <div class="full split-bottom-tightest">
                <div class="half left">
                    <div class="label">{{ $t('pages.employeeCoreData.civilStatus') }}</div>
                </div>
                <div class="half cd-input" v-bind:class="{roinput: !editing || DisallowEditingHiddenFields, mandatory:mandatoryAndMissing('civilStatus')}"> <!-- lower z-index then selection above ensure above selection overlays this one -->
                    <dropdownsearch v-if="editing && !DisallowEditingHiddenFields" style="width: 100%;" class="filters" :state="filtersCivilStatus"/>
                    <input v-else type="text" :readonly="true" v-model="displayCivilStatus"/>
                </div>
            </div>
            <div class="full">
                <div class="half left">
                    <div class="label">{{ $t('pages.employeeCoreData.address') }}</div>
                </div>
                <div class="half cd-input" v-bind:class="{roinput: !editing || DisallowEditingHiddenFields, mandatory:mandatoryAndMissing('address')}">
                    <input :readonly="!editing || DisallowEditingHiddenFields" type="text" v-model="savedEmployee.address"/>
                </div>
            </div>
            <div class="full">
                <div class="half left">
                    <div class="label">{{ $t('pages.employeeCoreData.postalCode') }}</div>
                </div>
                <div class="half cd-input" v-bind:class="{roinput: !editing || DisallowEditingHiddenFields, mandatory:mandatoryAndMissing('postalCode')}">
                    <input :readonly="!editing || DisallowEditingHiddenFields" type="text" v-model="savedEmployee.postalCode"/>
                </div>
            </div>
            <div class="full">
                <div class="half left">
                    <div class="label">{{ $t('pages.employeeCoreData.city') }}</div>
                </div>
                <div class="half cd-input" v-bind:class="{roinput: !editing || DisallowEditingHiddenFields, mandatory:mandatoryAndMissing('city')}">
                    <input :readonly="!editing || DisallowEditingHiddenFields" type="text" v-model="savedEmployee.city"/>
                </div>
            </div>
            <div class="full split-bottom-tightest">
                <div class="half left">
                    <div class="label">{{ $t('pages.employeeCoreData.country') }}</div>
                </div>
                <div class="half cd-input" v-bind:class="{roinput: !editing || DisallowEditingHiddenFields, mandatory:mandatoryAndMissing('country')}">
                    <dropdownsearch v-if="editing && !DisallowEditingHiddenFields" style="width: 100%;" class="filters" :state="filtersCountry"/>
                    <input v-else type="text" :readonly="true" v-model="displayCountry"/>
                </div>
            </div>
            <div class="full split-bottom-tightest">
                <div class="header">
                    <div class="label">{{ $t('pages.employeeCoreData.contact') }}</div>
                    <div v-show="false" class="header-right">
                        <div class="button small">
                            <div class="label">
                                {{ $t('pages.employeeCoreData.requestData') }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.homephone') }}</div>
                    </div>
                    <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory:mandatoryAndMissing('homephone')}">
                        <input :readonly="!editing" type="text" v-model="savedEmployee.homephone"/>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.mobilephone') }}</div>
                    </div>
                    <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory:mandatoryAndMissing('mobilephone')}">
                        <input :readonly="!editing" type="text" v-model="savedEmployee.mobilephone"/>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.email') }}</div>
                    </div>
                    <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory:mandatoryAndMissing('email')}">
                        <input :readonly="!editing" type="text" v-model="savedEmployee.email"/>
                    </div>
                </div>
            </div>
            

        </div>
        
        <div class="third right-nofloat">
            <div class="full split-bottom-tightest left">
                <div class="header">
                    <div class="label">{{ $t('pages.employeeCoreData.additionalDetails') }}</div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.mainPosition') }}</div>
                    </div>
                    <div class="half cd-input" style="z-index: 100;" >
                        <dropdownsearch v-if="!editing || creatingNewEmployee" style="width: 100%;" class="filters" :state="filtersSpot"/>
                        <input v-else type="text" :readonly="true" v-model="displaySpot"/>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.personnelNumber') }}</div>
                    </div>
                    <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory:mandatoryAndMissing('personnelId')}">
                        <input :readonly="!editing" type="text" v-model="savedEmployee.personnelId"/>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.taxId') }}</div>
                    </div>
                    <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory:mandatoryAndMissing('taxId')}">
                        <input :readonly="!editing" type="text" v-model="savedEmployee.taxId"/>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.firstEntry') }}</div>
                    </div>
                    <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory:mandatoryAndMissing('workEntryDate')}">
                        <input :readonly="!editing" type="date" v-model="dateOfWorkEntry"/>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.workExperience') }}</div>
                    </div>
                    <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory:mandatoryAndMissing('workExperience')}">
                        <input :readonly="!editing" type="text" v-model="displayWorkExperience"/>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.maxAppEmployeePreferences') }}</div>
                    </div>
                    <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory:mandatoryAndMissing('email')}">
                        <input :readonly="!editing || !CheckEditAppPreferences" type="text" v-model="maxAppEmployeePreferences"/>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.otherDetails') }}</div>
                    </div>
                    <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory:mandatoryAndMissing('miscInfo')}">
                        <textarea style="width: 100%; max-width: 100%;" :readonly="!editing" type="text" v-model="savedEmployee.miscInfo"/>
                    </div>
                </div>
                
            </div>

            <div class="full" v-bind:style="{border: editing && mandatoryAndMissing('gender')? 'solid 1px red' : 'none'}">
                <div class="third left">
                    <div class="label">{{ $t('pages.employeeCoreData.gender') }}</div>
                </div>
                <div class="twothird">
                    <div class="third">
                        <div class="label data">
                            {{ $t('pages.employeeCoreData.male') }} &nbsp;
                            <i class="fas fa-check-circle checkbox coredata" @click="savedEmployee.gender = 'M';" v-bind:class="{'true' : savedEmployee.gender == 'M', 'false' : savedEmployee.gender != 'M', 'disabled': !editing}"></i>
                        </div>
                    </div>
                    <div class="third">
                        <div class="label data">
                            {{ $t('pages.employeeCoreData.female') }} &nbsp;
                            <i class="fas fa-check-circle checkbox coredata" @click="savedEmployee.gender = 'F';" v-bind:class="{'true' : savedEmployee.gender == 'F', 'false' : savedEmployee.gender != 'F', 'disabled': !editing}"></i>
                        </div>
                    </div>
                    <div class="third">
                        <div class="label data">
                            {{ $t('pages.employeeCoreData.nonBinary') }} &nbsp;
                            <i class="fas fa-check-circle checkbox coredata" @click="savedEmployee.gender = 'D';" v-bind:class="{'true' : savedEmployee.gender == 'D', 'false' : savedEmployee.gender != 'D', 'disabled': !editing}"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="full">
                <div class="half left">
                    <div class="label">{{ $t('pages.employeeCoreData.socialInsuranceRegistered') }}</div>
                </div>
                <div class="half">
                    <i class="fas fa-check-circle checkbox coredata" @click="savedEmployee.socialInsuranceRegistered = !savedEmployee.socialInsuranceRegistered" v-bind:class="{'true' : savedEmployee.socialInsuranceRegistered, 'false' : !savedEmployee.socialInsuranceRegistered, 'disabled': !editing  || HasMlLicense}"></i>
                </div>
            </div>
            <div class="full">
                <div class="half left">
                    <div class="label">{{ $t('pages.employeeCoreData.disability') }}</div>
                </div>
                <div class="half">
                    <i class="fas fa-check-circle checkbox coredata" @click="savedEmployee.disability = !savedEmployee.disability" v-bind:class="{'true' : savedEmployee.disability, 'false' : !savedEmployee.disability, 'disabled': !editing}"></i>
                </div>
            </div>
            <!--<div class="full split-bottom-tightest">
                <div class="half left">
                    <div class="label">Religion</div>
                </div>
                <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory:mandatoryAndMissing('religion')}">
                    <input :readonly="!editing" type="text" v-model="savedEmployee.religion"/>
                </div>
            </div> -->
            <div class="full">
                <div class="label">{{ $t('pages.employeeCoreData.driverslicense') }}</div>
                <i class="fas fa-check-circle checkbox coredata" @click="savedEmployee.driverslicense = !savedEmployee.driverslicense" v-bind:class="{'true' : savedEmployee.driverslicense, 'false' : !savedEmployee.driverslicense, 'disabled': !editing}"></i>
            </div>
            <div class="full split-bottom-tightest">
                <div class="half left">
                    <div class="label">{{ $t('pages.employeeCoreData.expiryDate') }}</div>
                </div>
                <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory:mandatoryAndMissing('dlExpiry')}">
                    <input :readonly="!editing" type="date" v-model="dlExpiry"/>
                </div>
            </div>
            <div class="full">
                <div class="label">{{ $t('pages.employeeCoreData.firstaidcourse') }}</div>
                <i class="fas fa-check-circle checkbox coredata" @click="savedEmployee.firstaidcourse = !savedEmployee.firstaidcourse" v-bind:class="{'true' : savedEmployee.firstaidcourse, 'false' : !savedEmployee.firstaidcourse, 'disabled': !editing}"></i>
            </div>
            <div class="full split-bottom-tightest">
                <div class="half left">
                    <div class="label">{{ $t('pages.employeeCoreData.expiryDate') }}</div>
                </div>
                <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory:mandatoryAndMissing('faExpiry')}">
                    <input :readonly="!editing" type="date" v-model="faExpiry"/>
                </div>
            </div>
            <div class="full split-bottom-tightest" style="margin-top: 20px;">
                <div class="half left">
                    <div class="label">{{ $t('store.structure.sortPrio') }}</div>
                </div>
                <div class="half right" v-if="editing">
                    <slider style="left: -10px;" class="slider"
                                            :state="{inputControl: true, hideMin: true, hideMax: true, min: 1, max: 100,
                                             value: savedEmployee.sortPriority, step: 1, 
                                             DisplayLabel: (x) => {return x},
                                             sliderInput: (x) => {return x}, 
                                             labelToInt: (x) => {return x},
                                             
                                             }"
                                             @callback="(val, obj) => {savedEmployee.sortPriority = val;}"
                                            >
                    </slider>
                </div>
                <div v-else class="half cd-input" v-bind:class="{roinput: !editing}">
                        <input :readonly="!editing" type="text" v-model="savedEmployee.sortPriority"/>
                </div>

            </div>
           
                                
        </div>

        <div class="third right-nofloat">
            <div class="full split-bottom-tightest">
                <div class="header">
                    <div class="label">{{ $t('pages.employeeCoreData.bankConnection') }}</div>
                    <div v-show="false" class="header-right">
                        <div class="button small">
                            <div class="label">
                                {{ $t('pages.employeeCoreData.requestData') }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.bankAccountHolder') }}</div>
                    </div>
                    <div class="half cd-input" v-bind:class="{roinput: !editing || DisallowEditingHiddenFields, mandatory:mandatoryAndMissing('bankAccountHolder')}">
                        <input :readonly="!editing || DisallowEditingHiddenFields" type="text" v-model="savedEmployee.bankAccountHolder"/>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.iban') }}</div>
                    </div>
                    <div class="half cd-input" v-bind:class="{roinput: !editing || DisallowEditingHiddenFields, mandatory:mandatoryAndMissing('iban')}">
                        <input :readonly="!editing || DisallowEditingHiddenFields" type="text" v-model="savedEmployee.iban"/>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.bic') }}</div>
                    </div>
                    <div class="half cd-input" v-bind:class="{roinput: !editing || DisallowEditingHiddenFields, mandatory:mandatoryAndMissing('bic')}">
                        <input :readonly="!editing || DisallowEditingHiddenFields" type="text" v-model="savedEmployee.bic"/>
                    </div>
                </div>
            </div>
            
            <div class="full split-bottom-tightest left">
                <div class="header">
                    <div class="label">{{ $t('pages.employeeCoreData.healthInsurance') }}</div>
                </div>
                
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.healthInsurance') }}</div>
                    </div>
                    <div class="half cd-input" v-bind:class="{roinput: !editing}">
                        <input :readonly="!editing" type="text" v-model="savedEmployee.healthInsurance"/>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.healthInsuranceAddress') }}</div>
                    </div>
                    <div class="half cd-input" v-bind:class="{roinput: !editing}">
                        <input :readonly="!editing" type="text" v-model="savedEmployee.healthInsuranceAddress"/>
                    </div>
                </div>
                
            </div>

            <div class="full split-bottom-tightest">
                <div class="header">
                    <div class="label">{{ $t('pages.employeeCoreData.legalGuardian') }}</div>

                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.guardianName') }}</div>
                    </div>
                    <div class="half cd-input" v-bind:class="{roinput: !editing || DisallowEditingHiddenFields, mandatory:mandatoryAndMissing('guardianName')}">
                        <input :readonly="!editing || DisallowEditingHiddenFields" type="text" v-model="savedEmployee.guardianName"/>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.address') }}</div>
                    </div>
                    <div class="half cd-input" v-bind:class="{roinput: !editing || DisallowEditingHiddenFields, mandatory:mandatoryAndMissing('guardianAddress')}">
                        <input :readonly="!editing || DisallowEditingHiddenFields" type="text" v-model="savedEmployee.guardianAddress"/>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeCoreData.homephone') }}</div>
                    </div>
                    <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory:mandatoryAndMissing('guardianPhone')}">
                        <input :readonly="!editing" type="text" v-model="savedEmployee.guardianPhone"/>
                    </div>
                </div>
            </div>

            

            <div v-if="externalServices && externalServices.length > 0 && !editing" class="full split-bottom-tightest">
                <div class="header">
                    <div class="label">Externes System</div>
                </div>
                <div class="full">
                    <div class="third">
                            <div class="label m4-top">System</div>
                        </div>
                        <div class="twothirds" style="z-index: 10;">
                            <dropdownsearch style="width: 100%;" id="coredata-externaldata" :state="filtersExternalServices"/>
                        </div>
                </div>
                <div class="full"  v-if="externalService">
                    <div class="third">
                            <div class="label m4-top">Externe ID</div>
                        </div>
                        <div class="twothirds cd-input">
                            <input type="text" v-model="externalId"/>
                        </div>
                        <div class="full m8-top">
                            <buttonc v-if="showExternalDataSaveButton" @click="saveExternalData()" :label="$t('global.ui.save')" type="green" style="float: right; width: 120px; margin: 0px 0px 0px 8px;" />
                            <buttonc v-if="showExternalDataDeleteButton" @click="deleteCurrentExternalData()" :label="$t('global.ui.delete')" type="red" style="float: right; width: 120px; margin: 0;" />
                        </div>
                </div>
            </div>
            <div class="full split-bottom-tightest">

                <div class="full">
                    <div class="twothird left">
                        <div class="label">{{ $t('pages.employeeCoreData.rosterLegalChecks') }}</div>
                    </div>
                    <div class="third">
                        <i class="fas fa-check-circle checkbox coredata" @click="toggleUseRosterChecks()" v-bind:class="{'true' : savedEmployee.useRosterChecks, 'false' : !savedEmployee.useRosterChecks, 'disabled': !CheckIgnoreLaw || editing}"></i>
                    </div>
                </div>
                <div class="full">
                    <div class="twothird left">
                        <div class="label">{{ $t('pages.employeeCoreData.demoEmployee') }}</div>
                    </div>
                    <div class="third">
                        <i class="fas fa-check-circle checkbox coredata" v-bind:class="{'true' : savedEmployee.dummy, 'false' : !savedEmployee.dummy, 'disabled': true}"></i>
                    </div>
                </div>
                <div class="full">
                    <div class="twothird left">
                        <div class="label">{{ $t('pages.employeeCoreData.external') }}</div>
                    </div>
                    <div class="third">
                        <i class="fas fa-check-circle checkbox coredata" @click="savedEmployee.external = !savedEmployee.external" v-bind:class="{'true' : savedEmployee.external, 'false' : !savedEmployee.external, 'disabled': !editing}"></i>
                    </div>
                </div>
                
            </div>


        </div>
    </div>



</div>
</template>

<script>
import dropdownsearch from '../../uicomponents/dropdownsearch.vue'
 import { mapState, mapGetters } from 'vuex';
export default {
    components: {
        dropdownsearch
    },
    name: 'employeecoredata',
    data() {
        return {
            cuiData:{},
            countryMap:{},
            citizenTypeMap:{},
            civilStatusMap:{},
            filtersNationality: {},
            itemsNationality: [],
            filtersCountry: {},
            itemsCountry: [],
            filtersCitizen: {},
            itemsCitizen: [],
            filtersCivilStatus: {},
            itemsCivilStatus: [],
            cspots: [],
            filtersSpot: {},
            dataFiltered: [],
            processing: false,
            dragWatch: -1,
            mouseCurrent: {
                x: 0,
                y: 0
            },
            mouseDragStart: {
                x: 0,
                y: 0
            },
            scrolling: false,
            scrollTop: 150,
            dropdowns: [],
            savedEmployee: {},
            pendingChanges: false,
            editing: false,
            externalService: null,
            externalId: '',

            filtersExternalServices: {},
        }
    },
    watch: {
        savedEmployee: {
            deep: true,
            handler(val, old){
                this.checkForPendingChanges();
            }
        },
        nameFilter: function (val, oldVal) {
            if (val === '') {
                this.dataFiltered = this.gridData.data.slice();
                return;
            }
            this.dataFiltered = this.gridData.data.filter(e => (e.firstName.toLowerCase() + ' ' + e.lastName.toLowerCase()).indexOf(val.toLowerCase()) > -1);
        },
        spots: {
            handler(val, oldVal){
                this.cspots = val;
                this.updateSpotsDropdown();
            },
            deep: true
        },
        employee: function (val, oldVal){
           //console.log("employee changed")
            this.updateNationalityDropdown();
            this.updateCountryDropdown();
            this.updateCitizenTypeDropdown();
            this.updateCivilStatusDropdown();
            this.updateSpotsDropdown();
            this.updateExternalServicesDropdown();

            this.editing = this.creatingNewEmployee;
            this.savedEmployee = Object.assign({}, this.employee);
        }

    },
    props: [
        "employee",
        "spots",
        "uiData",
        "creatingNewEmployee",
    ],
    computed: {
        ...mapGetters([
            'isSuperUser',
            'permissions',
            'storeSettings',
            'externalServicesMap',
            'employeeExternalDataMap',
        ]),
        externalServices() {
            return Object.values(this.externalServicesMap);
        },
        mandatoryFields(){
            let specialGermanCompanies = [116, 136, 137];
            const ss = this.storeSettings;
            let mandatoryFields = [
                'firstName',
                'lastName',
                'email',
                'dob',
                'gender'
            ];
            if(specialGermanCompanies.includes(ss.companyId)){
                mandatoryFields.push('personnelId')
            }
            if(this.storeSettings.country == 2){
                mandatoryFields.push('workEntryDate');
            }
            return mandatoryFields;
        },
        HasMlLicense(){
            let res = false;
            if(this.storeSettings.mlLicExpiry != null){
                let today = this.$helpers.getMomentTZ();
                let date = this.$helpers.getMomentFromStringTZ(this.storeSettings.mlLicExpiry);
                if(today <= date){
                    res = true;
                }
            }
            
            return res;
        },
        CheckIgnoreLaw(){
            if(this.isSuperUser){
                    return true;
            }
            let res = false;
            Object.values(this.permissions).forEach(perms => {
                if(perms.map(perm => perm.id).includes(69)) { //permission to ignore law
                    res = true;
                }
            })

            return res;
        },
        CheckEditAppPreferences() {
            let val = false;
            Object.values(this.permissions).forEach(perms => {
                let perm = perms.find(p => p.id == 7);
                if (perm && perm.level > 2) {
                    val = true;
                }
            });
            console.log(val)
            return val;
        },
        DisallowEditingHiddenFields() {
            let res = false;
            Object.values(this.permissions).forEach(perms => {
                perms.forEach(perm => {
                    if(perm.id == 9 && perm.level < 3){
                        res = true;
                    }
                })
            })

            return res;
        },
        showExternalDataDeleteButton: function () {
            let show = false;

            if(!this.processing && this.employeeExternalData != null){
                this.employeeExternalData.forEach((data) => {
                    if(data.externalServiceId == this.externalService.id){
                        show = true;
                    }
                });
            }
            return show;
        },
        showExternalDataSaveButton: function () {
            let show = false;
            if((!this.employeeExternalData || this.employeeExternalData.length == 0) && this.externalId != '') {
                show = true;

            }
            if(!this.employeeExternalData.find(data => data.externalServiceId == this.externalService.id) && this.externalId != ''){
                show = true;
            } else {
                this.employeeExternalData.forEach((data) => {
                    if(data.externalServiceId == this.externalService.id && data.externalId != this.externalId && this.externalId != ''){
                        show = true;

                    }
                });
            }

            if(this.processing){
                show = false;
            }
            return show;
        },
        dateOfBirth: {
            get: function(){
                var dateStr;
                if(this.savedEmployee.dob){
                    dateStr = this.$helpers.extractDateString(this.savedEmployee.dob);
                }
                return dateStr;
            },
            set: function(val){
                this.savedEmployee.dob = this.$helpers.convertDateTimeStringUTC(val);
            }
        },
        dateOfWorkEntry: {
            get: function(){
                var dateStr;
                if(this.savedEmployee.workEntryDate){
                    dateStr = this.$helpers.getMomentFromStringTZ(this.savedEmployee.workEntryDate).format("YYYY-MM-DD");
                }
                return dateStr;
            },
            set: function(val){

                this.savedEmployee.workEntryDate = this.$helpers.getMomentFromStringTZ(val, "YYYY-MM-DD").format();
            }
        },
        maxAppEmployeePreferences: {
            get: function(){
                let str;
                if(this.savedEmployee.maxAppEmployeePreferences != null || this.editing){
                    str = this.savedEmployee.maxAppEmployeePreferences;
                } else {
                    str = 'Standard';
                }
                return str;
            },
            set: function(val){
                let v = parseFloat(val);
                if(isNaN(v)){
                    v = null;
                    this.savedEmployee.maxAppEmployeePreferences = v;
                } else {
                    this.savedEmployee.maxAppEmployeePreferences =  Math.max(0, Math.round(v));
                }
                
            }
        },
        dlExpiry: {
            get: function(){
                var dateStr;
                if(this.savedEmployee.dlExpiry){
                    dateStr = this.$helpers.extractDateString(this.savedEmployee.dlExpiry);
                }
                return dateStr;
            },
            set: function(val){
                this.savedEmployee.dlExpiry = this.$helpers.convertDateTimeStringUTC(val);
            }
        },
        faExpiry: {
            get: function(){
                var dateStr;
                if(this.savedEmployee.faExpiry){
                    dateStr = this.$helpers.extractDateString(this.savedEmployee.faExpiry);
                }
                return dateStr;
            },
            set: function(val){
                this.savedEmployee.faExpiry = this.$helpers.convertDateTimeStringUTC(val);
            }
        },
        displayNationality: {
            get: function(){
                var str = "";
                 if(this.savedEmployee.nationality != undefined){
                     str = this.countryMap[this.savedEmployee.nationality];
                 }
                 return str;
            }
        },
        displayCitizenType: {
            get: function(){
                var str = "";
                 if(this.savedEmployee.citizenType != undefined){
                     str = this.citizenTypeMap[this.savedEmployee.citizenType];
                 }
                 return str;
            }
        },
        displayCivilStatus: {
            get: function(){
                var str = "";
                 if(this.savedEmployee.civilStatus != undefined){
                     str = this.civilStatusMap[this.savedEmployee.civilStatus];
                 }
                 return str;
            }
        },
        displayCountry: {
            get: function(){
                var str = "";
                 if(this.savedEmployee.country != undefined){
                     str = this.countryMap[this.savedEmployee.country];
                 }
                 return str;
            }
        },
        displaySpot: {
            get: function(){
                var str = "";
                if(this.savedEmployee.spotId != undefined){
                    str = this.itemWithId(this.employee.spotId, this.spots).label;
                }
                return str;
            }
        },
        displayWorkExperience: {
            get: function(){
                let str = "";
                if(this.savedEmployee.workExperience){
                    str = Math.round(this.savedEmployee.workExperience);
                }
                return str;
            },
            set: function(val){
                let we = parseFloat(val);
                if(isNaN(we)){
                    we = 0;
                }
                this.savedEmployee.workExperience = Math.round(we);
            }
        },
        employeeExternalData() {
            let result = Object.values(this.employeeExternalDataMap).filter(ed => ed.employeeId == this.employee.id);

            return result;
        },

    },
    mounted(){

        this.cspots = this.spots;
        this.cuiData = this.uiData;
        // TODO: Get correct labels if lang != de
        this.cuiData.countries.forEach(item => this.countryMap[item.id] = this.$helpers.localizedLabel(this, item));
        this.cuiData.citizenTypes.forEach(item => this.citizenTypeMap[item.id] = this.$helpers.localizedLabel(this, item));
        this.cuiData.civilStatuses.forEach(item => this.civilStatusMap[item.id] = this.$helpers.localizedLabel(this, item));
        this.savedEmployee = Object.assign({}, this.employee);

        this.editing = this.creatingNewEmployee;

        this.updateCountryDropdown();
        this.updateNationalityDropdown();
        this.updateCitizenTypeDropdown();
        this.updateCivilStatusDropdown();
        this.updateSpotsDropdown();
        this.updateExternalServicesDropdown();

    },
    destroyed() {
    },
    methods: {
        //External Service Logic
        refreshExternalServiceData(force = false){
            let view = this;
            this.processing = true;
            this.$helpers.GetEmployeeExternalDataMap(force).then((externalData) => {


                view.$helpers.GetExternalServicesArray(force).then((services) => {
                    view.updateExternalServicesDropdown();
                    view.processing = false;
                });
            });
        },

        saveExternalData(){
            this.processing = true;
            var view = this;
            let externalId = this.externalId;
            let externalServiceId = this.externalService.id;
            let employeeId = this.employee.id;
            let payload = {
                employeeId: employeeId,
                externalServiceId: externalServiceId,
                externalId: externalId
            }
            // delete current external data if present
            if(this.employeeExternalData.length > 0){
                // TODO: currently always exactly 1 external data set, update this process if multiple needed
                let dataToDelete = null;
                this.employeeExternalData.forEach(data => {
                    if(data.externalServiceId == externalServiceId){
                        dataToDelete = data;
                    }
                });
                if(dataToDelete != null){
                    this.executeDeleteExternalData(dataToDelete.id).then(response => {
                        view.$store.commit("invalidateState", {states: ['employeeMissingExternalIdMapState']});
                        view.executeSaveExternalData(payload).then(response => {
                            view.$helpers.success('Externe ID gespeichert','');
                            view.refreshExternalServiceData(true);
                        }).catch(function (error) {
                            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.errorMessage'));
                            view.refreshExternalServiceData(true);
                            console.log(error);
                        });
                    }).catch(function (error) {
                        view.$helpers.error(view.$t('global.notifications.error'),error);
                        view.processing = false;
                        console.log(error)
                    });
                } else {
                    this.executeSaveExternalData(payload).then(response => {
                        view.$store.commit("invalidateState", {states: ['employeeMissingExternalIdMapState']});
                        view.$helpers.success('Externe ID gespeichert','');
                        view.refreshExternalServiceData(true);
                    }).catch(function (error) {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.errorMessage'));
                        view.refreshExternalServiceData(true);
                        console.log(error);
                    });
                }


            }else{
                this.executeSaveExternalData(payload).then(response => {
                    view.$store.commit("invalidateState", {states: ['employeeMissingExternalIdMapState']});
                    view.$helpers.success('Externe ID gespeichert','');
                    view.refreshExternalServiceData(true);
                }).catch(function (error) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.errorMessage'));
                    view.refreshExternalServiceData(true);
                    console.log(error);
                });
            }
        },
        deleteCurrentExternalData(){
            this.processing = true;
            let view = this;
            this.executeDeleteExternalData(this.employeeExternalData[0].id).then(response => {
                view.$store.commit("invalidateState", {states: ['employeeMissingExternalIdMapState']});
                view.$helpers.success('Externe ID gelöscht','');
                view.externalId = '';
                //view.externalService = null;
                view.refreshExternalServiceData(true);
            }).catch(function (error){
                 view.$helpers.error(view.$t('global.notifications.error'), this.$t('pages.comp.deleteDataError'));
                view.refreshExternalServiceData(true);
                console.log(error);
            });
        },
        executeDeleteExternalData(id){
            console.log('DELETING external data with ID: ' + id);
            let url = '/api/sec/employeeexternaldata';

            url = this.$helpers.appendParam("id", id, url, '/api/sec/employeeexternaldata');
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeexternaldata');
            console.log(url);
            return this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            });
        },
        executeSaveExternalData(payload){
            // save external data
            let url = '/api/sec/employeeexternaldata';
            let view = this;
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeexternaldata');

            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            })
        },
        updateExternalServicesDropdown() {
            let view = this;

            let itemsExternalServices = [];
            let selectedItem = {};
            this.externalId = '';
            this.externalServices.forEach( es=> {
                if(es.useExternalEmployeeIds) {
                    let cur = {
                        code: es.id,
                        label: es.name,
                        name: es.name,
                        obj: es
                    };
                    itemsExternalServices.push(cur);
                }
            })

            if(selectedItem.code == null && this.externalService != null){

                let serviceId = this.externalService.id;
                itemsExternalServices.forEach((i) => {
                    if(i.code == serviceId) {
                        selectedItem = i;
                        this.externalServices.forEach((s) => {
                            if(s.id == serviceId){
                                view.externalServiceSelected(s);
                            }
                        });
                    }
                });
            }
            if(selectedItem.code == null && this.employeeExternalData.length > 0){
                let serviceId = this.employeeExternalData[0].externalServiceId;
                itemsExternalServices.forEach((i) => {
                    if(i.code == serviceId) {
                        selectedItem = i;
                        this.externalServices.forEach((s) => {
                            if(s.id == serviceId){
                                view.externalServiceSelected(s);
                            }
                        });
                    }
                });
            }


            /* selectedItem = this.itemsExternalServices[0]; */
            console.log(selectedItem.name)
            this.filtersExternalServices = {
                toggled: false,
                displayedItems: itemsExternalServices,
                input: selectedItem.name,
                items: itemsExternalServices,
                onceSelected: function ($event, item, searchbar) {
                    view.externalServiceSelected(item.obj);
                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },
        externalServiceSelected(service){
            this.externalService = service;
            this.externalIdForExternalService(service);
        },
        externalIdForExternalService(service){
            this.externalId = '';
            let view = this;
            this.employeeExternalData.forEach((data) => {
                if(data.externalServiceId == service.id){
                    view.externalId = data.externalId;
                }
            });
        },
        toggleEditMode(){
            this.editing = !this.editing;
        },
        dobChanged($event) {
            this.dateOfBirth = $event.target.value;
        },
        cancelEditMode(){
            this.savedEmployee = Object.assign({}, this.employee);
            this.updateCountryDropdown();
            this.updateNationalityDropdown();
            this.updateCitizenTypeDropdown();
            this.updateCivilStatusDropdown();
            this.updateSpotsDropdown();
            this.editing = false;
            if(this.creatingNewEmployee){
                this.$emit('employee-creation-cancelled');
            }else{
                this.$emit('employee-edit-cancelled');
            }
        },
        mandatoryAndMissing(key){
            let specialGermanCompanies = [116, 136, 137];
            if(this.mandatoryFields.includes(key)){
                const ss = this.storeSettings;
                if(specialGermanCompanies.includes(ss.companyId) && key == 'personnelId'){
                    let value = this.savedEmployee[key]
                    let isMissing = this.$helpers.isEmpty(value);
                    let isNum = true;
                    if(!isMissing){
                        isNum = /^\d+$/.test(value);

                    }
                    return isMissing || !isNum;
                } else {
                    return this.$helpers.isEmpty(this.savedEmployee[key])
                }

                //return true;
            }
            return false;
        },
        toggleUseRosterChecks(){
            this.$emit('toggle-userosterchecks');
        },
        checkForPendingChanges(){
            var keys = Object.keys(this.savedEmployee);
            var changedKeys = [];
            keys.forEach(key => {
                if(key != 'metadata'){ // metadata is calculated employee state date added for frontend purpopses only
                    if(!(key in this.employee) || (this.savedEmployee[key] == null && this.employee[key] != null) || (this.savedEmployee[key] != null && this.employee[key] == null) || this.savedEmployee[key] != this.employee[key]){
                        changedKeys.push(key);
                    }
                }
            });
            this.pendingChanges = changedKeys.length > 0;
            return changedKeys;
        },
        updateNationalityDropdown(){
            var view = this;
            this.itemsNationality = [];

            this.cuiData.countries.sort((a, b) => a.label_de.localeCompare(b.label_de)).forEach(val => {
                this.itemsNationality.push({code: val.id, label: this.$helpers.localizedLabel(this, val), name: this.$helpers.localizedLabel(this, val)});
            })
            var selectedItem = {};
            for(const item of this.itemsNationality) if(item.code == this.employee.nationality) selectedItem = item;

            this.filtersNationality = {
                toggled: false,
                displayedItems: this.itemsNationality,
                input: this.employee.nationality != undefined ? view.countryMap[view.employee.nationality] : this.$t('pages.employeeCoreData.selectionPrompt'),
                items: Object.values(this.itemsNationality),
                onceSelected: function ($event, item, searchbar){
                    view.savedEmployee.nationality = item.code;
                    view.checkForPendingChanges();
                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },
        updateCountryDropdown(){
            var view = this;
            this.itemsCountry = [];
            // dropdown data country
            this.cuiData.countries.sort((a, b) => a.label_de.localeCompare(b.label_de)).forEach(val => {
                this.itemsCountry.push({code: val.id, label: this.$helpers.localizedLabel(this, val), name: this.$helpers.localizedLabel(this, val)});
            })

            var selectedItem = {};
            for(const item of this.itemsCountry) if(item.code == this.employee.country) selectedItem = item;

            this.filtersCountry = {
                toggled: false,
                displayedItems: this.itemsCountry,
                input: this.employee.country != undefined? this.countryMap[this.employee.country] : this.$t('pages.employeeCoreData.selectionPrompt'),
                items: Object.values(this.itemsCountry),
                onceSelected: function ($event, item, searchbar){
                    view.savedEmployee.country = item.code;
                    view.checkForPendingChanges();
                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },
        updateCitizenTypeDropdown(){
            var view = this;
            this.itemsCitizen = [];
            // dropdown data citizenType
            for(const val of this.cuiData.citizenTypes){
                this.itemsCitizen.push({code: val.id, label: this.$helpers.localizedLabel(this, val), name: this.$helpers.localizedLabel(this, val)});
            }
            var selectedItem = {};
            for(const item of this.itemsCitizen) if(item.code == this.employee.citizenType) selectedItem = item;

            this.filtersCitizen = {
                toggled: false,
                displayedItems: this.itemsCitizen,
                input: this.employee.citizenType != undefined? this.citizenTypeMap[this.employee.citizenType] : this.$t('pages.employeeCoreData.selectionPrompt'),
                items: Object.values(this.itemsCitizen),
                onceSelected: function ($event, item, searchbar){
                    view.savedEmployee.citizenType = item.code;
                    view.checkForPendingChanges();
                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },
        updateCivilStatusDropdown(){
            var view = this;
            this.itemsCivilStatus = [];
            // dropdown data citizenType
            for(const val of this.cuiData.civilStatuses){
                this.itemsCivilStatus.push({code: val.id, label: this.$helpers.localizedLabel(this, val), name: this.$helpers.localizedLabel(this, val)});
            }
            var selectedItem = {};
            for(const item of this.itemsCivilStatus) if(item.code == this.employee.civilStatus) selectedItem = item;

            this.filtersCivilStatus = {
                toggled: false,
                displayedItems: this.itemsCivilStatus,
                input: this.employee.civilStatus != undefined? this.civilStatusMap[this.employee.civilStatus] : this.$t('pages.employeeCoreData.selectionPrompt'),
                items: Object.values(this.itemsCivilStatus),
                onceSelected: function ($event, item, searchbar){
                    view.savedEmployee.civilStatus = item.code;
                    view.checkForPendingChanges();
                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },
        updateSpotsDropdown(){
            var view = this;
            var selectedItem = {};
            var items = [];
            items.push({
                id: null,
                name: "   ",
                label: "   "
            });
            for(const item of this.cspots){
                if(item.id == this.employee.spotId) selectedItem = item;
                item.label = item.name;
                items.push(item);
            }

            // dropdown data spots
            this.filtersSpot = {
                toggled: false,
                displayedItems: items,
                input: this.employee.spotId != undefined? this.itemWithId(this.employee.spotId, this.spots).label : this.$t('pages.employeeCoreData.selectionPrompt'),
                items: items,
                onceSelected: function ($event, item, searchbar){
                    if(view.creatingNewEmployee){
                        view.savedEmployee.spotId = item.id;
                        view.checkForPendingChanges();
                    } else {
                        view.linkEmployeeToSpot(item.id);
                    }
                    
                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },
        itemWithId(id, arr){
            for(const item of arr){
                if(item.id == id) return item;
            }
            // fallback, should not happen
            return {id: '' , name: '', label: ''};
        },
        Init(items, config) {},
        gender(code){
            switch(code){
                case 'm':
                case 'M':
                    return this.$t('pages.employeeCoreData.male');
                case 'f':
                case 'F':
                    return this.$t('pages.employeeCoreData.female');
                default:
                    return this.$t('pages.employeeCoreData.nonBinary');
            }
        },
        getChangedEmployee(){
            this.savedEmployee.id = this.employee.id;
            this.savedEmployee.dummy = this.employee.dummy;
            return this.savedEmployee;
        },
        linkEmployeeToSpot(spotId){
            let view = this;
            let url = '/api/sec/employee/linkspot';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/linkspot');
            let payload =  {
                id: this.employee.id,
                spotId: spotId,
                deleteOldSkill: false,
                skillValue: 10,
            }

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                if(response.data.type && response.data.type == 'SUCCESS'){
                    view.$helpers.success(view.$t('pages.employeeCoreData.changesSavedHeader'), view.$t('pages.employeeCoreData.changesSavedBody'));
                    view.employee.spotId = spotId;
                    view.employee.spotId = spotId;
                    view.$emit('updated', view.employee.id, true);
                    
                }
                
            }).catch(function (error) {
                view.$helpers.error(view.$t('pages.employeeCoreData.errorSavingHeader'), view.$t('pages.employeeCoreData.errorSavingBody'));
                console.log(error)
            })
        },
        updateChangedFields(generateChangePdf=false){
            var changedKeys = this.checkForPendingChanges();
            let changedData = {
                firstName: this.employee.firstName,
                lastName: this.employee.lastName,
                empldob: this.employee.dob,
                emplsocialsecurity: this.employee.socialsecurity
            };
            changedKeys.forEach((key) => {
                let val = this.savedEmployee[key];
                let oldVal = this.employee[key];
                // TODO: Translate fields
                if(key == 'citizenType'){
                    for(const ct of this.cuiData.citizenTypes){
                        if(ct.id == val) val = ct.label_de;
                        if(ct.id == oldVal) oldVal = ct.label_de;
                    }
                }else if(key == 'civilStatus'){
                    for(const ct of this.cuiData.civilStatuses){
                        if(ct.id == val) val = ct.label_de;
                        if(ct.id == oldVal) oldVal = ct.label_de;
                    }
                }else if(key == 'country' || key == 'nationality'){
                    for(const ct of this.cuiData.countries){
                        if(ct.id == val) val = ct.label_de;
                        if(ct.id == oldVal) oldVal = ct.label_de;
                    }
                }else if(key == 'spotId'){
                    for(const s of this.cspots){
                        if(s.id == val) val = s.name;
                        if(s.id == oldVal) oldVal = s.name;
                    }
                }else if(key == 'email'){
                    val = val ? val.toLowerCase().trim() : val;
                }
                changedData[key] = {
                    val: val,
                    oldVal: oldVal
                }
            });
            if(changedKeys.length > 0){
                let view = this;
                let ok = true;
                let pnOk = true;
                let genderOK = true;
                this.mandatoryFields.forEach(field => {
                    let fOk = !this.mandatoryAndMissing(field);
                    ok = ok && fOk;
                    if(field == "personnelId" && !fOk){
                        pnOk = false;
                    }
                })
                genderOK = !this.mandatoryAndMissing('gender');
                if(ok){
                    
                    let keys = [];
                    changedKeys.forEach(key => {
                        if(key != 'metadata'){ // metadata is only calculated info added for frontend
                            keys.push(key);
                            
                        }
                    });
                    if(keys.length > 0){
                        let url = '/api/sec/employee';
                        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee');

                        let payload = {
                            'id': this.employee.id,
                            'updateFields': keys
                        }
                        keys.forEach(key => {
                            payload[key] = this.savedEmployee[key];
                        });
                        this.axios({
                            method: 'put',
                            headers: {
                                'AUTHORIZATION': "bearer "+this.$store.state.jwt
                            },
                            url: url,
                            data: payload
                        }).then(response => {
                            if(response.data.type && response.data.type == 'SUCCESS'){
                                view.$helpers.success(view.$t('pages.employeeCoreData.changesSavedHeader'), view.$t('pages.employeeCoreData.changesSavedBody'));
                                keys.forEach(key => {
                                    this.employee[key] = this.savedEmployee[key];
                                });
                                view.$emit('updated', view.employee.id, true)
                                if(generateChangePdf) view.$emit('coredata-updated', changedData, view.employee);
                                view.checkForPendingChanges();
                                view.$forceUpdate();
                            }
                            view.editing = false;
                        }).catch(function (error) {
                            view.$helpers.error(view.$t('pages.employeeCoreData.errorSavingHeader'), view.$t('pages.employeeCoreData.errorSavingBody'));
                            //view.$emit('updated', view.employee.id, true)
                            //view.editing = false;
                            console.log(error)
                        });
                    }
                } else {
                    if(!pnOk){
                        this.$helpers.error(this.$t('pages.employeeCoreData.errorSavingHeader'), this.$t('pages.employeeCoreData.errorCreatingEmployeeMandatoryCheckPN'));
                    }else if(!genderOK){
                        this.$helpers.error(this.$t('pages.employeeCoreData.errorSavingHeader'), this.$t('pages.employeeCoreData.errorCreatingEmployeeMandatoryCheckGender'));
                    }else{
                        this.$helpers.error(this.$t('pages.employeeCoreData.errorSavingHeader'), this.$t('pages.employeeCoreData.errorCreatingEmployeeMandatoryCheck'));
                    }
                }

            }
        },
        createEmployee(){
            let ok = true;
            let pnOk = true;
            let genderOK = true;
            this.mandatoryFields.forEach(field => {
                let fOk = !this.mandatoryAndMissing(field);
                ok = ok && fOk;
                if(field == "personnelId" && !fOk){
                    pnOk = false;
                }
            })
            genderOK = !this.mandatoryAndMissing('gender');

            if(ok){
                this.$helpers.log(this, 'createEmployee', this.employee);
                this.$emit('create-employee', this.savedEmployee);
            } else {
                if(!pnOk){
                    this.$helpers.error(this.$t('pages.employeeCoreData.errorSavingHeader'), this.$t('pages.employeeCoreData.errorCreatingEmployeeMandatoryCheckPN'));
                } else if(!genderOK){
                    this.$helpers.error(this.$t('pages.employeeCoreData.errorSavingHeader'), this.$t('pages.employeeCoreData.errorCreatingEmployeeMandatoryCheckGender'));
                } else {
                    this.$helpers.error(this.$t('pages.employeeCoreData.errorSavingHeader'), this.$t('pages.employeeCoreData.errorCreatingEmployeeMandatoryCheck'));
                }

            }

        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.dropdown-search.filters {
    height: 18px !important;
    margin-top: -4px;
    display: block;
}

.slider {
    width: calc(100% - 40px) !important;
}

/*
.content *:not(.main-settings)>.half {
    height: 105px;
}
*/
</style>
